<template>
  <div class="q-pa-md">
    <q-card flat bordered>
      <q-tabs
        v-model="tab"
        dense
        outside-arrows
        mobile-arrows
        :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 '"
        active-color="white"
        :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
        :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
        align="left"
        narrow-indicator
      >
        <template v-for="{ name, label, tooltip } in tabNames" :key="name">
          <q-tab class="text-weight-light" :name="name" :label="label" no-caps>
            <q-tooltip v-if="tooltip">{{ tooltip }}</q-tooltip>
          </q-tab>
          <q-separator vertical />
        </template>
      </q-tabs>
      <q-separator />

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel
          v-for="{ name, component } in tabNames"
          :key="name"
          :name="name"
          class="q-pa-none"
        >
          <keep-alive>
            <component :is="component" :symbol="symbol" />
          </keep-alive>
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
</template>

<script setup>
import { ref, onMounted, markRaw } from "vue";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

import StockWiseDimensionCharts from "src/components/StockWiseDimensionCharts.vue";
import StockWiseFYComparison from "src/components/StockWiseFYComparison.vue";
import StockDividends from "src/components/StockDividends.vue";
import AnnouncementComponent from "src/components/AnnouncementComponent.vue";

const props = defineProps({
  symbol: {
    type: String,
  },
});

const $route = useRoute();
const $q = useQuasar();

let tab = ref("");
const tabNames = ref([
  {
    name: "quarterly_report",
    label: "Quarter Report",
    tooltip: "Quarter Report",
    component: markRaw(StockWiseFYComparison),
  },
  {
    name: "fundamental_chart",
    label: "Fundamental Trend",
    tooltip: "Fundamental",
    component: markRaw(StockWiseDimensionCharts),
  },

  {
    name: "stock_dividends",
    label: "Dividend",
    tooltip: "Dividend",
    component: markRaw(StockDividends),
  },
  {
    name: "announcement",
    label: "Announcement",
    tooltip: "Announcement",
    component: markRaw(AnnouncementComponent),
  },
]);

const fundamentalTabs = [
  "quarterly_report",
  "fundamental_chart",
  "stock_dividends",
  "announcement",
];

function changeTab() {
  const { query, name } = $route;
  if (name === "StockProfile") {
    tab.value = fundamentalTabs.includes(query?.signal)
      ? query?.signal
      : query?.signal_fundamental || "quarterly_report";
  } else {
    tab.value = "quarterly_report";
  }
}

onMounted(() => {
  changeTab();
});
</script>
